import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import { Button, Dialog, Grid } from "@material-ui/core";
import CreateBillingTierModal from "../../Components/Modal/CreateBillingTierModal";
import Signifier from "../../Components/Signifier";
import SortableTable from "../../Components/Table/SortableTable";
import BillingTierCell from "../../Components/Table/BillingTierCell";
import axios from "axios";
import { ClientBillingTier } from "../../Types/ClientBilling";
import { useClientBillingTiers } from "../../Helpers/billingTierDefaultPricing";

function convertToDate(date?: Date | string | null) {
  return date ? new Date(date) : undefined;
}

export function convertBillingTierDates(tierData: ClientBillingTier[]) {
  return tierData.map((tier) => ({
    ...tier,
    createdDate: convertToDate(tier.createdDate)!.toLocaleString(),
    modifiedDate: convertToDate(tier.modifiedDate)?.toLocaleString(),
    deletedDate: convertToDate(tier.deletedDate)?.toLocaleString(),
  }));
}

const columns = [
  { label: "Name", propName: "tierName" },
  { label: "Created On", propName: "createdDate" },
  { label: "Last Modified", propName: "modifiedDate" },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "50%",
    marginBottom: "50px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

function BillingTiersPage() {
  const classes = useStyles();
  const { isLoading, tiers } = useClientBillingTiers();
  const [showSignifier, setShowSignifier] = useState(false);
  const [showCreateTierError, setShowCreateTierError] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [createTierErrorMessage, setCreateTierErrorMessage] = useState("Error Adding Tier");
  axios.defaults.headers.common["client"] = "";

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message="Tier Added"
        error={showCreateTierError}
        errorMessage={createTierErrorMessage}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Billing Tiers</h1>
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <Button
                color="primary"
                style={{ color: "white", marginBottom: "15px", marginLeft: "0px" }}
                type="submit"
                variant="contained"
                onClick={() => setOpenModal(true)}
              >
                Add Tier
              </Button>
            </Grid>
          </Grid>
          <SortableTable
            columns={columns}
            tableData={tiers}
            rowComponent={BillingTierCell}
            loading={isLoading}
            hideSearch={false}
            defaultSortIndex={undefined}
            setTableData={undefined}
            reverse={undefined}
            pagination={undefined}
            totalItemCount={undefined}
          />
        </div>
      </div>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <CreateBillingTierModal
          openModal={setOpenModal}
          setShowSignifier={setShowSignifier}
          setShowError={setShowCreateTierError}
          setCreateTierErrorMessage={setCreateTierErrorMessage}
        />
      </Dialog>
    </>
  );
}

export default BillingTiersPage;
